import styled, { css } from "styled-components";

// Off-screen but still in the accessibility tree — and, on a form control,
// still focusable.
export const srOnly = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export const SrOnly = styled.span`
  ${srOnly}
`;
